import { useForm } from 'react-hook-form'

import { Navigation, Radio } from '@itau-loans-www/components'
import { submitOnChange } from '@itau-loans-www/hooks'

import useLoanReason from './hooks'
import './loan-reason.scss'

const LoanReason = () => {
  const initialValues = {
    reason: ''
  }

  const { handleSubmit, control, setValue } = useForm({
    mode: 'onChange',
    defaultValues: initialValues
  })

  const { onSubmit, reasonOptions } = useLoanReason({ setValue })

  return (
    <div className="loan-reason">
      <div className="container">
        <h1 className="proposal-title">
          Pra terminarmos, qual é o seu objetivo com o empréstimo?
        </h1>

        <p className="loan-reason__optional">resposta opcional</p>
      </div>
      <form className="form">
        <Radio
          box
          options={reasonOptions}
          id="reason"
          name="reason"
          colClassName="values-radio"
          gridClassName="loanData-grid"
          rules={{
            isRequired: true
          }}
          grid={{
            mobile: 6,
            tablet: 6,
            desktop: 6
          }}
          control={control}
          onChange={() => {
            submitOnChange(handleSubmit(onSubmit))
          }}
        />
        <Navigation
          onNextStepClick={onSubmit}
          prevButtonId={'desired-loan-data-prev-btn'}
          nextButtonText="Formalizar proposta"
        />
      </form>
    </div>
  )
}

export default LoanReason
